<template>
  <div class="m-page">
    <div class="m-content">
      <el-scrollbar wrap-class="m-scroll-wrap">
        <div class="m-login-config">
          <div class="m-group-header">{{$t('management.login.login_page_config')}}</div>
          <div class="m-list m-sys-info">
            <el-form
              :model="this"
              label-position="top"
              ref="form"
              :rules="rules"
            >
              <el-form-item
                :label="$t('management.login.system_type')"
              >
                <el-radio-group
                  v-model="identifyType"
                  type="simple"
                >
                  <el-radio-button label="0">{{$t('management.login.system_type_combine')}}</el-radio-button>
                  <el-radio-button label="1">{{$t('management.login.system_type_image')}}</el-radio-button>
                </el-radio-group>
                <div class="m-preview-box" v-if="identifyType==='1'">
                  <bg-upload
                    type="platformIdentifyImg"
                    v-model="identifyImgInfo"
                  ></bg-upload>
                  <div class="tip">{{$t('management.login.system_type_image_tip')}}</div>
                </div>

              </el-form-item>
              <el-form-item
                :label="$t('management.login.system_name_label')"
                prop="systemName"
                v-if="identifyType==='0'"
              >
                <div class="m-preview-input-box" >
                  <el-input
                    v-model="systemName"
                    :placeholder="$t('management.login.system_name_placeholder')"
                  ></el-input>
                </div>

              </el-form-item>
              <el-form-item
                 v-if="identifyType==='0'"
                :label="$t('management.login.system_subname_label')"
                prop="systemSubtitle"
              >
                <el-input
                  v-model="systemSubtitle"
                  :placeholder="$t('management.login.system_subname_placeholder')"
                ></el-input>
              </el-form-item>
              <el-form-item  v-if="identifyType==='0'" :label="$t('management.login.login_page_logo')">
                <icon-upload
                  type="loginLogo"
                  v-model="loginLogoInfo.fileId"
                  :selected="selected"
                  :listLength="3"
                  @change="changeIcon"
                ></icon-upload>
                <div class="tip">{{$t('management.login.tip_text_logo')}}</div>
              </el-form-item>
            </el-form>
          </div>
          <div class="m-list m-foreground">
            <el-form label-position="top">
              <el-form-item :label="$t('management.login.front_img_type')">
                <el-radio-group
                  v-model="foregroundType"
                  type="simple"
                >
                  <el-radio-button label="0">{{$t('management.login.img')}}</el-radio-button>
                  <el-radio-button label="1">{{$t('management.login.animate')}}</el-radio-button>
                </el-radio-group>
                <div class="m-preview-box">
                  <bg-upload
                    v-if="foregroundType==='0'"
                    type="loginBgImg"
                    v-model="ctImgInfo"
                  ></bg-upload>
                  <animat-upload
                    v-if="foregroundType==='1'"
                    type="loginBgImg"
                    v-model="ctZipInfo"
                  ></animat-upload>
                </div>
                <div class="tip">{{foregroundType==='0'? $t('management.login.tip_text'):$t('management.login.tip_animate')}}</div>
              </el-form-item>
            </el-form>
          </div>
          <div class="m-list m-background">
            <el-form label-position="top">
              <el-form-item :label="$t('management.login.behind_img_type')">
                <el-radio-group
                  v-model="backgroundType"
                  type="simple"
                >
                  <el-radio-button label="0">{{$t('management.login.img')}}</el-radio-button>
                  <el-radio-button label="1">{{$t('management.login.color')}}</el-radio-button>
                </el-radio-group>
                <div
                  class="m-preview-box"
                  v-if="backgroundType==='0'"
                >
                  <bg-upload
                    type="loginBgImg"
                    v-model="backgroundImgInfo"
                  ></bg-upload>
                  <div
                    class="tip"
                    v-if="backgroundType==='0'"
                  >{{$t('management.login.tip_bgi')}}</div>
                </div>

                <color-picker
                  class="m-color-picker"
                  v-else
                  show-fallback
                  :max-height="316"
                  popover-to="right"
                  v-model="bgColor"
                >
                </color-picker>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="m-login-style">
          <div class="m-group-header">{{$t('management.login.login_page_style')}}</div>
          <img
            @click="nowSchema = 'login-type1'"
            :class="{'brand-border-color':nowSchema==='login-type1',
            'active':nowSchema==='login-type1'
            }"
            src="../../../assets/images/longin_style2.png"
          >
          <img
            @click="nowSchema = 'login-type2'"
            :class="{'brand-border-color':nowSchema==='login-type2',
            'active':nowSchema==='login-type2'
            }"
            src="../../../assets/images/longin_style1.png"
          >
          <div class="m-foot-bar">
            <el-button
              type="primary"
              @click="onSet"
            >{{$t('management.login.apply')}}</el-button>
            <el-button
              type="default"
              @click="onPreview"
            >{{$t('management.login.preview')}}</el-button>
          </div>
        </div>
        <redirect />
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import bgUpload from 'components/bg-upload/bg-upload'
import iconUpload from 'components/icon-upload/icon-upload'
import colorPicker from 'vue-swatches'
// import colorPicker from 'components/color-picker/src/main.vue'
import animatUpload from './animat-upload'
import redirect from './redirect'
import Api from 'api/api'
import ApiConfig from 'api/config'
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
import {
  charRule,
  allSpaceRule,
  max64ChartRule,
  requireRule
} from 'utils/validator'
export default {
  name: 'login-configuration',
  data () {
    // const identifyImgInfoRule =  (rule, value, callback) => {
    //   if (value.fileId === -1) {
    //     callback(new Error('不能为空'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loginSchema: 'login-type1',
      nowSchema: '',
      systemName: '',
      systemSubtitle: '',
      loginLogoInfo: {
        fileId: -1,
        path: ''
      },
      backgroundImgInfo: {
        fileId: -1,
        path: ''
      },
      ctImgInfo: {
        fileId: -1,
        path: ''
      },
      ctZipInfo: {
        fileId: -1,
        path: ''
      },
      identifyImgInfo: {
        fileId: -1,
        path: ''
      },
      showCopyRight: false,
      rules: {
        systemName: [charRule, allSpaceRule, max64ChartRule, requireRule],
        systemSubtitle: [charRule, allSpaceRule, max64ChartRule, requireRule],
        // identifyImgInfo:[{validator:identifyImgInfoRule,trigger:'change'}]
      },
      bgColor: null,
      imageMode: 'full',
      selected: -1,
      nowIcon: {},
      identifyType: '0',
      identifyImgId:'',
      foregroundType: '0',
      backgroundType: '0',
      systemNameColor: 'rgba(255,255,255,0)'
    }
  },
  watch: {
    // identifyType (val) {
    //   if(val === '1') this.$refs.form.resetValidate('systemName')
    // }
  },
  computed: {
    previewImageSrc () {
      if (this.nowSchema === 'login-type1') {
        return `${ApiConfig.context}/static/images/login_layout1.png`
      } else {
        return `${ApiConfig.context}/static/images/login_layout2.png`
      }
    }
  },
  methods: {
    _getInfo () {
      let _loadingInstance = this._getLoading()
      Api.login
        .query()
        .then(res => {
          _loadingInstance.close()
          this.loginSchema = res.data.loginSchema
          this.nowSchema = this.loginSchema
          this.nowIcon = res.data.loginLogoInfo
          this.systemName = res.data.systemName || ''
          this.systemSubtitle = res.data.systemSubtitle || ''
          this.loginLogoInfo = res.data.loginLogoInfo || {
            fileId: -1,
            path: ''
          }
          this.foregroundType = res.data.cImgType
          this.backgroundType = res.data.bgImgType
          this.bgColor = res.data.bgColor
          this.backgroundImgInfo = res.data.backgroundImgInfo || {
            fileId: -1,
            path: ''
          }
          this.ctImgInfo = res.data.ctImgInfo || {
            fileId: -1,
            path: ''
          }
          this.ctZipInfo = res.data.ctZipInfo || {
            fileId: -1,
            path: ''
          }
          this.identifyImgInfo =  res.data.identifyImgInfo || {
            fileId: -1,
            path: ''
          }
          this.showCopyRight = res.data.showCopyRight
          this.imageMode = res.data.imageMode
          this.selected = this.loginLogoInfo.fileId
          this.systemNameColor = res.data.systemNameColor || 'rgba(255,255,255,0)'
          this.identifyType = res.data.identifyType
          this.identifyImgId= res.data.identifyImgId
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    _setInfo (params) {
      let _loadingInstance = this._getLoading()
      Api.login
        .set(params)
        .then(res => {
          _loadingInstance.close()
          this.loginSchema = this.nowSchema
          this.selected = this.loginLogoInfo.fileId
          this.$message.success(this.$t('management.login.set_success'))
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    onSet () {
      //判断如果平台标识类型是图片
      if(this.identifyType === '1' && this.identifyImgInfo.fileId === -1) {
        return this.$message.warning(this.$t('management.login.system_image_valid_null'))
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          let _params = this.$lodash.cloneDeep({
            bgColor: this.bgColor,
            bgImgId: this.backgroundImgInfo.fileId,
            bgImgType: this.backgroundType,
            cImgType: this.foregroundType,
            ctImgId: this.ctImgInfo.fileId,
            ctZipId: this.ctZipInfo.fileId,
            systemName: this.systemName,
            systemSubtitle: this.systemSubtitle,
            loginSchema: this.nowSchema,
            loginLogo: this.loginLogoInfo.fileId,
            identifyType:this.identifyType,
            identifyImgId:this.identifyImgInfo.fileId,
            identifyImgInfo:this.identifyImgInfo
            // showCopyRight: this.showCopyRight,
            // imageMode: this.imageMode
          })
          this._setInfo(_params)
        }
      })
    },
    onPreview () {
      let _params = {
        backgroundImgInfo: this.backgroundImgInfo,
        bgColor: this.bgColor,
        bgImgType: this.backgroundType,
        cImgType: this.foregroundType,
        ctImgInfo: this.ctImgInfo,
        ctZipId: this.ctZipInfo.fileId,
        ctZipInfo: this.ctZipInfo,
        systemName: this.systemName,
        systemSubtitle: this.systemSubtitle,
        loginLogoInfo: this.nowIcon,
        loginSchema: this.nowSchema,
        systemNameColor: this.systemNameColor,
        identifyType:this.identifyType,
        identifyImgId:this.identifyImgInfo.fileId,
        identifyImgInfo:this.identifyImgInfo
        // showCopyRight: this.showCopyRight,
        // imageMode: this.imageMode,
      }
      this.$storage.set('login-info', _params)
      window.open(`${ApiConfig.context}/login.html?lpw=true`)
    },
    onReset () {
      this._getInfo()
    },
    changeIcon (icon) {
      this.nowIcon = icon
    }
  },
  mounted () {
    this._getInfo()
  },
  mixins: [ErrorHandleMixin, LoadingMixin],
  components: {
    bgUpload,
    iconUpload,
    colorPicker,
    animatUpload,
    redirect
  }
}
</script>
<style scoped lang="less" rel="stylesheet/less">
.login-configuration.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  position: relative;
  .top-wrapper {
    height: 220px;
    position: relative;
    font-size: 0;
    overflow: hidden;
    .left-wrapper {
      display: inline-block;
      vertical-align: top;
      width: auto;
      .bg-upload {
        height: 152px;
        width: 232px;
      }
    }
    .middle-wrapper {
      display: inline-block;
      vertical-align: top;
    }
    .right-wrapper {
      display: inline-block;
      vertical-align: top;
    }
  }
  .bottom-wrapper {
    position: absolute;
    top: 228px;
    left: 16px;
    right: 16px;
    bottom: 16px;
    .selected {
      display: inline-block;
      width: 16px;
      height: 16px;
      vertical-align: middle;
      position: relative;
      top: -2px;
    }
    .preview-wrapper {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 68px;
      .image-wrapper {
        position: absolute;
        left: 0;
        right: 0;
        top: 47px;
        bottom: 0;
      }
    }
    .button-wrapper {
      height: 52px;
      bottom: 0;
      left: 0;
      position: absolute;
    }
  }
}
.m-page {
  width: 100%;
  height: 100%;
  /deep/ .vue-swatches.m-color-picker {
    .vue-swatches__wrapper {
      width: 223px !important;
    }
  }
  .m-content {
    width: 100%;
    height: 100%;
    /deep/ .m-scroll-wrap {
      position: absolute !important;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      .m-group-header {
        width: 100%;
        height: 26px;
        font-size: 18px;
        color: rgba(0, 0, 0, 0.9);
        margin-bottom: 16px;
        text-indent: 36px;
      }
      .m-login-config {
        width: 1056px;
        height: 376px;
        padding: 40px 0 48px;
        margin: 0 auto;
        .m-list {
          float: left;
          width: 280px;
          margin: 0 36px;
          .tip {
            width: 100%;
            line-height: 20px;
            margin-top: 4px;
            color: rgba(0, 0, 0, 0.4);
          }
          .m-preview-box {
            width: 240px;
            height: 108px;
            margin-top: 8px;
          }
          .m-preview-input-box {
            margin-top: 8px;
          }
          .m-color-picker {
            display: block;
            margin-top: 8px;
          }
        }
      }
      .m-login-style {
        width: 1056px;
        margin: 0 auto;
        overflow: hidden;
        img {
          margin-left: 36px;
          cursor: pointer;
          border-radius: 4px;
          border: 2px solid transparent;
          :hover {
            border: 2px solid transparent;
          }
        }
        .m-foot-bar {
          padding-left: 36px;
          margin-top: 48px;
        }
      }
    }
  }
  .m-footer {
    width: 100%;
    height: 56px;
    box-shadow: inset 0 1px 0 0 rgba(0, 0, 0, 0.12);
  }
}
</style>
